export const endpoints = {
  all: (host: string) => `${host}/channel/full.json`,
  channelPackages: (host: string) =>
    `${host}/alderaan/channels/from-channel-packages`,
};
